export default function (val, currency = 'BRL') {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency:
      currency === '$' || currency === 'USD' || currency === 'US$'
        ? 'USD'
        : 'BRL',
    minimumFractionDigits: 2,
  });
  return formatter.format(val);
}
